import {SetGetBet} from './thunk/setGetBet';
import {SetGetCreditHistory} from './thunk/setGetCreditHistory';
import {SetGetEventHistoryList} from './thunk/setGetEventHistoryList';
import {SetGetGamerInformation} from './thunk/setGetGamerInformation';
import {SetGetGamerList} from './thunk/setGetGamerList';
import {SetGetOperatorDetalization} from './thunk/setGetOperatorDetalization';
import {SetGetViewGroup} from './thunk/setGetViewGroup';
import {SetGroups} from './thunk/setGroups';
import {SetPostUpdateBalance} from './thunk/setPostUpdateBalance';

export const Thunks = {
    SetGetBet,
    SetGetCreditHistory,
    SetGetEventHistoryList,
    SetGetGamerInformation,
    SetGetGamerList,
    SetGetOperatorDetalization,
    SetGetViewGroup,
    SetGroups,
    SetPostUpdateBalance
}